/*
 * Project: forca
 * File Created: Monday, 4th October 2021 12:28:21 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import { createGlobalState } from 'react-hooks-global-state';

const { setGlobalState, useGlobalState } = createGlobalState({
	isPenstionsinfoLoggedin: false,
	loggedInType: (sessionStorage['loginType'] && JSON.parse(sessionStorage['loginType'])?.type) || 'ukendt'
});

export const setPenstionsinfoLoggedin = (value: boolean) => {
	setGlobalState('isPenstionsinfoLoggedin', () => ( value ));
};

export const setLoggedInType = (value: string) => {
	setGlobalState('loggedInType', () => ( value ));
};

export { useGlobalState };